import SituacaoIdDescricaoBase from '@/dominio/SituacaoIdDescricaoBase';
import { green, red } from '@mui/material/colors';

/**
 * Enum para situações de presença de representante de parte.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const PRESENCA_REPRESENTANTE_PARTE = {
    SEM_INFORMACAO: { id: 'SEM_INFORMACAO', descricao: 'Presença não cadastrada', descricaoPresencaCurta: 'Não cadastrada', cor: 'black',    codigo: 'NA' },
    PRESENTE:       { id: 'PRESENTE',       descricao: 'Advogado presente',       descricaoPresencaCurta: 'Presente',       cor: green[700], codigo: 'S'  },
    AUSENTE:        { id: 'AUSENTE',        descricao: 'Advogado ausente',        descricaoPresencaCurta: 'Ausente',        cor: red[900],   codigo: 'N'  }
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de presença de representante de parte.
 * @readonly
 */
export default class PresencaRepresentanteParte {
    static situacaoBase = new SituacaoIdDescricaoBase(PRESENCA_REPRESENTANTE_PARTE);
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_INSCRICAO_ADVOGADO =
        'Não foi possível identificar a situação da presença de advogado.';
    static DESCONHECIDO = 'Informação desconhecida';

    static getDescricao(id) {
        return PresencaRepresentanteParte.situacaoBase.getDescricao(id);
    }

    static getDescricaoPresencaCurta(id) {
        return PresencaRepresentanteParte.situacaoBase.getValorPropriedade(id, 'descricaoPresencaCurta');
    }

    static getDescricaoPresencaCurtaByCodigo(codigo) {
        const obj = PresencaRepresentanteParte.situacaoBase.getObjectByProperty('codigo', codigo);

        if (!obj) {
            console.warn(`Situação "${codigo}" desconhecida.`);
            return PresencaRepresentanteParte.DESCONHECIDO;
        }

        return PresencaRepresentanteParte.getDescricaoPresencaCurta(obj.id);
    }

    static getCor(id) {
        return PresencaRepresentanteParte.situacaoBase.getValorPropriedade(id, 'cor');
    }

    static getCorByCodigo(codigo) {
        const obj = PresencaRepresentanteParte.situacaoBase.getObjectByProperty('codigo', codigo);

        if (!obj) {
            console.warn(`Situação "${codigo}" desconhecida.`);
        }

        return obj ? PresencaRepresentanteParte.getCor(obj.id) : 'black';
    }

    static getCodigo(id) {
        return PresencaRepresentanteParte.situacaoBase.getValorPropriedade(id, 'codigo');
    }

    static getIdByCodigo(codigo) {
        if (!codigo) {
            return PRESENCA_REPRESENTANTE_PARTE.SEM_INFORMACAO.id;
        }

        const obj = PresencaRepresentanteParte.situacaoBase.getObjectByProperty('codigo', codigo);

        if (!obj) {
            console.debug(`Situação de presença "${codigo}" desconhecida.`);
        }

        return obj ? obj.id : '';
    }
}
